/**
 * Bảy bước trong luồng xử lý một trang — PRS §4, khớp thanh bước của mockup BA.
 *
 * Đặt ở FE chứ không ở `packages/shared` vì hai lý do:
 *  1. Đây là dữ liệu trình bày (nhãn tiếng Việt, lý do bị khoá), không phải
 *     hợp đồng dữ liệu giữa BE và FE.
 *  2. `shared` biên dịch ra CommonJS nên Rollup không phân giải được giá trị
 *     lúc chạy khi nó đi qua `export *` — FE chỉ import KIỂU từ `shared` được.
 *
 * `available: false` = chưa làm được ở giai đoạn 1; bước đó vẫn hiện trong thanh
 * nhưng mờ đi kèm lý do, để người xem thấy phạm vi thật thay vì tưởng bị thiếu.
 */
export interface FlowStep {
  key: 'source' | 'google' | 'keyword' | 'analysis' | 'recs' | 'content' | 'report';
  label: string;
  available: boolean;
  blockedReason: string | null;
}

export type FlowStepKey = FlowStep['key'];

export const FLOW_STEPS: readonly FlowStep[] = [
  { key: 'source', label: 'Đọc mã nguồn', available: true, blockedReason: null },
  {
    key: 'google',
    label: 'Dịch vụ Google',
    available: false,
    blockedReason:
      'Chờ Google Service Account cấp tổ chức — cần quyền trên GA4, Tag Manager, Search Console và DNS.',
  },
  {
    key: 'keyword',
    label: 'Từ khoá chính',
    available: false,
    blockedReason: 'Cần cấu hình dịch vụ AI ở màn quản trị.',
  },
  { key: 'analysis', label: 'Phân tích SEO', available: true, blockedReason: null },
  // Nhãn bỏ chữ "áp dụng" (spec SC-02 §5): Copilot đọc trang qua HTTP, nó không
  // có mã nguồn của ai để mà áp dụng gì. Hứa trong nhãn rồi không làm được là
  // cách nhanh nhất làm người dùng mất tin vào phần còn lại.
  { key: 'recs', label: 'Đề xuất chỉnh sửa', available: true, blockedReason: null },
  {
    key: 'content',
    label: 'Nội dung AI sinh',
    available: false,
    blockedReason: 'Cần cấu hình dịch vụ AI ở màn quản trị.',
  },
  { key: 'report', label: 'Báo cáo', available: true, blockedReason: null },
];
